import "./FormSection.css";

export default function FormSection({

    title,

    description,

    icon,

    actions,

    children,

    className = ""

}){

    return(

        <section

            className={`form-section ${className}`}

        >

            {

                (title || description || actions) &&

                <div className="form-section-header">

                    <div className="form-section-title">

                        {

                            icon &&

                            <div className="form-section-icon">

                                {icon}

                            </div>

                        }

                        <div>

                            {

                                title &&

                                <h3>

                                    {title}

                                </h3>

                            }

                            {

                                description &&

                                <p>

                                    {description}

                                </p>

                            }

                        </div>

                    </div>

                    {

                        actions &&

                        <div className="form-section-actions">

                            {actions}

                        </div>

                    }

                </div>

            }

            <div className="form-section-body">

                {children}

            </div>

        </section>

    );

}